import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * @file Created on Mon Aug 06 2018
 * @author VBr
 * @author LZe
 */


import { jsonConversions, PriceZone } from '@logio/common-be-fe';
import { List } from 'immutable';
import { action, computed, observable, runInAction } from 'mobx';
import { PriceZoneLayer } from '../../transportLayers/zones/PriceZoneLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
/**
 * This store obtaining data of price zones.
 */

export var PriceZoneStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(PriceZoneStore, _BaseStore);

  function PriceZoneStore() {
    var _this;

    _classCallCheck(this, PriceZoneStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceZoneStore).apply(this, arguments));
    _this.name = StoreName.PriceZone;
    _this.priceZoneLayer = new PriceZoneLayer();
    _this.list = new Map();

    _this.create = function (priceZone) {
      return _this.priceZoneLayer.createWithProgress(priceZone).then(function (response) {
        return response;
      });
    };

    return _this;
  }

  _createClass(PriceZoneStore, [{
    key: "getAll",
    value: function getAll() {
      var _this2 = this;

      return this.priceZoneLayer.findAll().then(function (priceZones) {
        runInAction(function () {
          priceZones.forEach(function (zone) {
            if (zone.id) {
              _this2.list.set(zone.id, zone);
            }
          });
        });
        return _this2.list;
      });
    }
  }, {
    key: "getOne",
    value: function getOne(zoneId) {
      var _this3 = this;

      return this.priceZoneLayer.findOne(zoneId).then(function (priceZone) {
        runInAction(function () {
          _this3.list.set(priceZone.id, priceZone);
        });
        return priceZone;
      });
    }
  }, {
    key: "update",
    value: function update(priceZone) {
      var _this4 = this;

      return this.priceZoneLayer.update(priceZone).then(function (zone) {
        runInAction(function () {
          _this4.list.set(zone.id, zone);
        });
      });
    }
  }, {
    key: "archive",
    value: function archive(priceZone) {
      var _this5 = this;

      return this.priceZoneLayer.archive(priceZone.id).then(function () {
        runInAction(function () {
          _this5.list.set(priceZone.id, _this5.priceZoneLayer.getConverter().toObject(Object.assign(Object.assign({}, _this5.priceZoneLayer.getConverter().toDocument(priceZone, jsonConversions)), {
            archived: true
          }), jsonConversions));
        });
      });
    }
  }, {
    key: "changeCompetitors",
    value: function changeCompetitors(priceZoneIds, competitorSiteIds) {
      var _this6 = this;

      return this.priceZoneLayer.changeCompetitors(priceZoneIds, competitorSiteIds).then(function (priceZones) {
        runInAction(function () {
          priceZones.forEach(function (zone) {
            if (zone.id) {
              _this6.list.set(zone.id, zone);
            }
          });
        });
        return priceZones;
      });
    }
  }, {
    key: "listNotArchived",
    get: function get() {
      return new Map(_toConsumableArray(this.list).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            k = _ref2[0],
            zone = _ref2[1];

        return !zone.archived;
      }));
    }
  }, {
    key: "nationalZone",
    get: function get() {
      return List(this.list.values()).find(function (z) {
        return z.isNational && !z.archived;
      });
    }
  }]);

  return PriceZoneStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], PriceZoneStore.prototype, "list", void 0);

__decorate([computed, __metadata("design:type", Object), __metadata("design:paramtypes", [])], PriceZoneStore.prototype, "listNotArchived", null);

__decorate([computed, __metadata("design:type", Object), __metadata("design:paramtypes", [])], PriceZoneStore.prototype, "nationalZone", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], PriceZoneStore.prototype, "getAll", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], PriceZoneStore.prototype, "getOne", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [PriceZone]), __metadata("design:returntype", Promise)], PriceZoneStore.prototype, "update", null);

__decorate([action.bound, __metadata("design:type", Object)], PriceZoneStore.prototype, "create", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [PriceZone]), __metadata("design:returntype", Promise)], PriceZoneStore.prototype, "archive", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Array, Array]), __metadata("design:returntype", Promise)], PriceZoneStore.prototype, "changeCompetitors", null);